export default {
  GET_MENULISTS: 'GET_MENULISTS',
  GET_USERACCESS: 'GET_USERACCESS',
  FETCH_PERMISSSION_REQUEST: 'FETCH_PERMISSSION_REQUEST',
  FETCH_PERMISSSION_SUCCESS:'FETCH_PERMISSSION_SUCCESS'
}